export class ChannelGroup {
  constructor({icon, name, channels}) {
    this.icon = icon;
    this.name = name;
    this.channels = channels;
  }
}

export class ChannelGroupHeader {
  constructor({
                icon, name, action, actionIcon
              }) {
    this.icon = icon;
    this.name = name;
    this.action = action;
    this.actionIcon = actionIcon;
  }
}
